
// Common
import HTMLDsbElement from 'https://stmaadev.blob.core.windows.net/stc-maa-dev-fw-site/scripts/scriptloader/HTMLDsbElement/class-HTMLDsbElement-fetch,mustache-v1.1.0.es.js';

//CSS
import _CSS from '../../dest/css/dsb-modal.min.css';

export default class extends HTMLDsbElement {
  constructor() {
    let root_template = document.createElement('template');
    root_template.setAttribute('data-label','root_template');

    let root_template__header = document.createElement('header');
    let root_template__header_ul = document.createElement('ul');
    root_template__header_ul.classList = 'two_tray';
    root_template__header.append(root_template__header_ul);
    let root_template__header_ul_li_one = document.createElement('li');
    root_template__header_ul_li_one.classList = 'tray_left';
    root_template__header_ul.append(root_template__header_ul_li_one);
    let root_template__header_ul_li_two = document.createElement('li');
    root_template__header_ul_li_two.classList = 'tray';
    root_template__header_ul.append(root_template__header_ul_li_two);
    root_template.content.append(root_template__header);

    let root_template__body = document.createElement('article');
    root_template__body.setAttribute('data-dsb-template_key','innerHTML');
    let root_template__body_slot = document.createElement('slot');
    root_template__body.append(root_template__body_slot)
    root_template__body_slot.setAttribute('dsb-template-type',"move");
    root_template.content.append(root_template__body);

    super({'component_name':'dsb-modal','css':_CSS,'root_template':root_template,'onReady':function(element,_this){
      _this.dsb.helpers.add('modal','addToTray',function(type,icon_class,label,callback){
        if(icon_class.length==0)
        {
          throw 'Missing param[0], icon_class'
        }
        if(type.length==0 || !["left","right"].includes(type))
        {
          throw 'Missing param[0], type'
        }
        if(!(typeof callback === 'function'))
        {
          throw 'Missing param[2], callback or callback is not a function'
        }
        let item = element.querySelector('header ul li.'+(type==='left'?'tray_left':'tray'));
        if(item instanceof HTMLElement)
        {

          let close = document.createElement('div');
          let close_button = document.createElement('span');
          close_button.innerHTML=label;
          close_button.classList=icon_class;
          close_button.onclick=callback;
          close.append(close_button);
          item.append(close);
        }
        else
        {
          throw 'header not found!';
        }

      });
      _this.dsb.helpers.add('modal','setContent',function(content){
        _this.root_template__body='';
        if(content instanceof HTMLElement)
        {
          root_template__body.append(content);
        }
        else
        {
          let tmp_element = document.createElement('template');
          tmp_element.innerHTML = content;
          root_template__body.appendChild(tmp_element.content);
        }
      });

    }});

    this._settings=false;
    this._data_sources = '';
    this._has_init=false;

  }

  get show(){
      return this.getAttribute('show');
  }

  set show(newValue)
  {
    this.setAttribute('show',newValue);
    _refreshVisability();
  }

  _refreshVisability()
  {
    if(this.show == 'true' || this.show == 'yes')
    {
      this.style.display="grid";
    }
    else
    {
      this.style.display="none";
    }
  }

  async _render()
  {
    let _this = this;
    if(!this._has_init)
    {
      this.dsb.helpers.run('modal','addToTray',["left","icon-back icon-clickable","",function(){_this.remove();}]);
      this.dsb.helpers.run('modal','addToTray',["right","icon-info icon-clickable","One",function(){alert('clicked one');}]);
      this.dsb.helpers.run('modal','addToTray',["right","icon-info icon-clickable","Two",function(){alert('clicked two');}]);
      if(this.dsb.element.innerHTML.trim() == "")
      {
        if(this.dsb.helpers.has('html','spinner'))
        {
          this.dsb.element.innerHTML=this.dsb.helpers.run('html','spinner');
        }
        else
        {
          this.dsb.element.innerHTML='Loading...';
        }
      }
      let modal_target = 'body';
      if(this.hasAttribute('data-dsb-modalTargetId'))
      {
        modal_target=document.getElementById(this.getAttribute('data-dsb-modalTargetId'));
      }

      if(modal_target instanceof HTMLElement)
      {
        modal_target.appendChild(this);
      }
      else
      {
        document.body.appendChild(this);
      }

      _refreshVisability();
    }

  }
}

